import { AxiosRequestConfig } from 'axios';

import Client from './client';
import { Credit } from './types';

type Response = {
  readonly result: string;
  readonly status: number;
  credit: Credit;
};

export default (id = 'me', config?: AxiosRequestConfig) => {
  return Client.get<Response>(`/uc/v1/credit/user/${id}`, config);
};
